module.exports = __webpack_public_path__ + "static/media/hail-damaged-cars.8f747268.png";